var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrokenImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.3503 63.3499L40.4653 36.4649L9.36864 5.36824L4.6503 0.649902L0.185303 5.1149L7.5003 12.4616V54.1666C7.5003 57.6499 10.3503 60.4999 13.8336 60.4999H55.5386L62.8536 67.8149L67.3503 63.3499ZM13.8336 50.9999L24.917 36.7499L32.8336 46.2816L36.5386 41.4999L46.0386 50.9999H13.8336ZM64.5003 51.5382L16.462 3.4999H58.167C61.6503 3.4999 64.5003 6.3499 64.5003 9.83324V51.5382Z",
    fill: "#E89989"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenImage);
export default __webpack_public_path__ + "static/media/broken-image.712d4501.svg";
export { ForwardRef as ReactComponent };